import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=88a3e68c&scoped=true"
import script from "./Popular.vue?vue&type=script&lang=js"
export * from "./Popular.vue?vue&type=script&lang=js"
import style0 from "./Popular.vue?vue&type=style&index=0&id=88a3e68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a3e68c",
  null
  
)

export default component.exports